import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContractorsService } from '../contractors.service';
import { DatePipe } from '@angular/common';
import { AgNumberCountComponent } from 'src/app/core/components';
import { GLOBAL } from 'src/app/app.globals';

@Component({
  selector: 'app-contractor-details',
  templateUrl: './contractor-details.component.html',
  styleUrls: ['./contractor-details.component.css']
})
export class ContractorDetailsComponent implements OnInit {
  date = new DatePipe('en-US');
  @Input() data: any;
  @Input() contractorType: number;
  @Input() states: any;
  contractors: any;
  contactNumber: string = '';
  purchaseDetails: Array<any> = [];
  registrationDetails: Array<any> = [];
  subContractorDetails: Array<any> = [];
  licenseDetails: Array<any> = [];
  ecpolicyDetails: Array<any> = [];
  documentDetails: Array<any> = [];
  contactDetails: Array<any> = [];
  showGrid:boolean = false;
  @Output() public handleClose: EventEmitter<void> = new EventEmitter();
 
  documentColDefs: any[] =[];
  registrationColDefs: any[] = [];
  licenseColDefs: any[] =  [];
  ecpolicyColDefs: any[] =[];
  contactColDefs: any[] = [];
  purchaseColDefs: any[] = [
    {
      headerName: "#",
      field: '',
      width: 5,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" },
      cellRendererFramework: AgNumberCountComponent
    },
    {
      headerName: "WorkOrder No",
      field: "WorkOrderNo",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Order Start Date",
      field: "IssueDate",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Order End Date",
      field: "ValidityDate",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Person",
      field: "Person",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
  ];

  subContractorColDefs: any[] = [
    {
      headerName: "Vendor Code",
      field: "Vendor Code",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Sub Contractor",
      field: "Sub Contractor",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Email ID",
      field: "EmailID",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "PAN Number",
      field: "PAN Number",
      width: 10,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    }
  ];
  constructor(
    private contractorsService: ContractorsService) { }

  async ngOnInit() {    
    if (!this.data || !this.data.ContractorVendor_Code) {
      console.error('ERROR: ContractorDetailsComponent - data or ContractorVendor_Code is undefined');
      return;
    }
    
    this.setRegistrationCol();
    this.setLicenseCol();
    this.setEcpolicyCol();
    this.setDocumentCol();
    this.setContactCol();
   
    await this.contractorsService.getMultiTableList(this.data.ContractorVendor_Code, this.contractorType).subscribe((res: any) => {
      this.purchaseDetails = res.Table1 || [];
      this.licenseDetails = res.Table2 || [];
      this.ecpolicyDetails = res.Table3 || [];
      this.contractors = res.Table4 && res.Table4.length > 0 ? res.Table4[0] : {};
      this.contactDetails = res.Table5 || [];
      this.contactNumber = res.Table5 && res.Table5.length > 0 ? res.Table5[0].MobileNo : '';
      this.documentDetails = res.Table6 || [];
      this.registrationDetails = res.Table7 || [];
      this.subContractorDetails = res.Table8 || [];
    });

  }
  setContactCol(){
    this.contactColDefs = [
      {
        headerName: "#",
        field: '',
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent
      },
      {
        headerName: "Name",
        field: "FullName",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Designation",
        field: "Designation",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Email",
        field: "EmailID",
        width: 25,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Phone",
        field: "PhoneNo",
        width: 15,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Mobile",
        field: "MobileNo",
        width: 15,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      }
    ];
  }

  setDocumentCol(){
    this.documentColDefs = [
      {
        headerName: "#",
        field: '',
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent
      },
      { 
        headerName: 'Document Name', 
        field: 'DocName', 
        width: 30,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      { 
        headerName: 'File Name', 
        field: 'UploadFileName', 
        width: 30,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      { 
        headerName: 'Uploaded Date', 
        field: 'CreatedDate', 
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      { 
        headerName: 'Is Verify?', 
        field: 'IsVerify', 
        width: 15,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      { 
        headerName: 'Verify Date', 
        field: 'VerifyDate', 
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: 'View',
        field: '',
        width: 10,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRenderer: (params) => {
          if (params.data.ParentRootFolder) {
            return `<a href="${GLOBAL.DOC_URL}${params.data.ParentRootFolder}" target="_blank"><i class="fa fa-eye" style="cursor: pointer; color: #4fc5ea;"></i></a>`;
          }
          if (params.data.DocLink) {
            return `<a href="${GLOBAL.DOC_URL}${params.data.DocLink}" target="_blank"><i class="fa fa-eye" style="cursor: pointer; color: #4fc5ea;"></i></a>`;
          }
          return '-';
        }
      }
    ];
  }
  setRegistrationCol(){
    this.registrationColDefs = [
      {
        headerName: "#",
        field: '',
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent
      },
      {
        headerName: "Type",
        field: "Type",
        width: 30,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "State",
        field: "State",
        width: 30,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Registration Number",
        field: "Registration No",
        width: 40,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      }
    ];
  }
  gethtmlcontent(param){
    return '<div>'+param.value+'</div>';
  }
  getStateName(stateCode){
      let stateList = JSON.parse(localStorage.getItem('stateList'));
      if(stateCode.value != null && stateList && stateList.length > 0){
        let statename='';
        stateList.forEach((state) => {
          if (state.State_Code == stateCode.value) {
            statename = state.StateName;
          }
          });
        return statename;
      }else{
        return '';
      }
  }

  getFileIconWithfiletype(filename){
    if(filename != null || filename != ''){
      let fileType = filename.substring(filename.lastIndexOf('.') + 1);
      let iconContent='';
      if (fileType === 'pdf') {
          iconContent = '<i class="fa fa-file-pdf-o"></i>';
      }
      else if(fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
        iconContent = '<i class="fa fa-image"></i>';
      }
      else if (fileType === 'doc' || fileType === 'docx') {
        iconContent = '<i class="fa fa-file"></i>';
      } else if (fileType === 'xls' || fileType === 'xlsx') {
        iconContent = '<span class="icon-saD-doc-xlsx"></span>';
      } else {
        iconContent = '';
      }
      return iconContent;
    }else{
      return '';
    } 
  }
  setLicenseCol(){
    this.licenseColDefs = [
      {
        headerName: "#",
        field: '',
        width: 5,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: AgNumberCountComponent
      },
      {
        headerName: "License No",
        field: "LicenseNo",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Star Date",
        field: "IssueDate",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        //valueFormatter: params => { return this.date.transform(params.value, 'short') }
      },
      {
        headerName: "End Date",
        field: "ValidityDate",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" },
        //valueFormatter: params => { return this.date.transform(params.value, 'short') }
      },
      {
        headerName: "Person",
        field: "Person",
        width: 20,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "Plant",
        field: "Plant",
        width: 15,
        sortable: false,
        suppressMenu: true,
        cellStyle: { "text-align": "center" }
      },
    ];
  }
  

setEcpolicyCol(){
	this.ecpolicyColDefs= [
    {
      headerName: "#",
      field: '',
      width: 5,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" },
      cellRendererFramework: AgNumberCountComponent
    },
    {
      headerName: "ECPolicy No",
      field: "ECPolicyNo",
      width: 20,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Star Date",
      field: "IssueDate",
      width: 20,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" },
      //valueFormatter: params => { return this.date.transform(params.value, 'short') }
    },
    {
      headerName: "End Date",
      field: "ValidityDate",
      width: 20,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" },
      //valueFormatter: params => { return this.date.transform(params.value, 'short') }
    },
    {
      headerName: "Person",
      field: "Person",
      width: 20,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
    {
      headerName: "Plant",
      field: "Plant",
      width: 15,
      sortable: false,
      suppressMenu: true,
      cellStyle: { "text-align": "center" }
    },
  ];
}
  /**
   * To close modal popup
   * @author Sagar Dhrangdhariya
   * @memberof ContractorDetailsComponent
   */
  public onCloseAction() {
    this.handleClose.emit();
  }
}
